import StudentRegistrationCursusAdmin from "../views/schooladmin/StudentRegistrationCursusAdmin";
import StudentRegistrationCursusAdminAddEdit from "../views/schooladmin/StudentRegistrationCursusAdminAddEdit";

export default [{
    path: "/schooladmin/studentregistrationcursusadmin",
    components: {
      content: StudentRegistrationCursusAdmin
    }
  },
  {
    path: "/schooladmin/studentregistrationcursusadmin/new",
    components: {
      content: StudentRegistrationCursusAdminAddEdit
    }
  },
  {
    path: "/schooladmin/studentregistrationcursusadmin/update/:id",
    components: {
      content: StudentRegistrationCursusAdminAddEdit
    },
    props: {
      content: true
    }
  }
];